/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROSUPPLIER", "184")


  
    
export interface API19664Item {
  
  /** 上传url */
  uploadAddress?: string;
  
  /** 上传后的名字 */
  uploadFileName?: string;
  
  /** 文件大小,单位为byte */
  uploadFileSize?: number;
  
};
    
  



export interface API19664Req {
  
  /** 上传文件 */
  files: string;
  /** 上传路径 */
  uploadPath: string;
  /** 文件类型，1音频2视频3其他 */
  fileType: string;
  /** 文件名 */
  fileNames: string;
};



export interface API19664Res {
  /** T  */
  list?: API19664Item[];
  /**   */
  totalNumber?: number;
  /**   */
  totalPage?: number;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: number;
  /**   */
  pageIndex?: number;
  
};


// 19664 上传资源

export interface IUsePostAPI19664Return {
  /** 上传资源: 接口请求状态 */
  isAPI19664Loading: boolean;
  /** 上传资源: 接口请求返回数据 */
  dataAPI19664: API19664Res;
  /**  上传资源: 接口数据请求方法 */
  fetchAPI19664Data:  (inputs: API19664Req, config?: YWRequestConfig) => Promise<API19664Res>;
  /** 上传资源: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI19664 = ():IUsePostAPI19664Return => {
  let isMount = true;
  const [isAPI19664Loading, setIsAPI19664Loading] = useState(false);
  const [dataAPI19664, setDataAPI19664] = useState<API19664Res>({} as API19664Res);
  const requestUrl = `${basePath}/ywwl-supply-chain-admin/new/resource/uploadFiles`;

  const fetchAPI19664Data = async (inputs: API19664Req, config?: YWRequestConfig): Promise<API19664Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API19664Req>) || {}) as API19664Req;
    
  
    if ( isMount ) {
      setIsAPI19664Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API19664Res>(`${basePath}/ywwl-supply-chain-admin/new/resource/uploadFiles`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI19664(res || {} as API19664Res);
        setIsAPI19664Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI19664Loading(false);
      }
      return false as unknown as API19664Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI19664Loading,
    dataAPI19664,
    fetchAPI19664Data,
    requestUrl,
  }
}

